export const CustomTreeViewItemName = 'customTreeViewItemComponent';
